module.exports = __webpack_public_path__ + "media/4.260b1585.mp3";